import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from '../core/rest';

export const GetTargetAgencies = createAsyncThunk(
    "crossAgencyAssignments/GetTargetAgencies",
    async ({ page, rowsPerPage, sourceAgencyId, targetAgencyName }) => {
        try {
            const url = `${ApiGatewayUrl}/crossagency?page=${page}&rows_per_page=${rowsPerPage}&source_agency_id=${sourceAgencyId}&target_agency_name=${targetAgencyName}`;
            const response = await Rest.get(url);
            return response.data;
        } catch (ex) {
            ErrorException(ex.response);
            throw ex;
        }
    }
);

export const AssignCrossAgency = createAsyncThunk(
    "crossAgencyAssignments/AssignCrossAgency",
    async (assignCrossAgencyData) => {
        try {
            const response = await Rest.post(`${ApiGatewayUrl}/crossagency`, assignCrossAgencyData);
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const UnAssignCrossAgency = createAsyncThunk(
    "crossAgencyAssignments/UnAssignCrossAgency",
    async (targetAgencyId) => {
        try {
            const response = await Rest.delete(`${ApiGatewayUrl}/crossagency/${targetAgencyId}`);
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const crossAgencySlice = createSlice({
    name: "crossAgency",
    initialState: {
        allowAgencies: [],
        sourceAgencies: [],
        selectedAgencyId: 0,
        total: 0,
        targetAgencies: [],
    },
    reducers: {
        saveSelectedAgencyId: (state, action) => {
            state.selectedAgencyId = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(GetTargetAgencies.fulfilled, (state, action) => {
                return {
                    ...state,
                    targetAgencies: action.payload.targetAgencies,
                    sourceAgencies: action.payload.sourceAgencies,
                    allowAgencies: action.payload.allowAgencies,
                    total: action.payload.total
                }
            })
            .addCase(AssignCrossAgency.fulfilled, (state) => {
                return {
                    ...state,
                }
            })
    }
});

export const crossAgencyActions = crossAgencySlice.actions;
export const crossAgencyState = (state) => state.crossAgency;
export default crossAgencySlice.reducer;